<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      福永站<br>
站点介绍<br>
福永站位于宝安大道与福洲大道交叉口处,沿宝安大道呈南北走向布置，该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:23	23:54	11号线	4分钟	6分32秒<br>
碧头	06:28	00:12	11号线	4分钟	6分32秒<br>
左炮台东	06:17	23:57	12号线	4分钟	8分钟<br>
海上田园东	06:34	23:14	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:23	23:54	11号线	4分34秒	6分钟<br>
碧头	06:28	00:12	11号线	4分34秒	6分钟<br>
左炮台东	06:18	23:57	12号线	8分钟	8分钟<br>
海上田园东	06:34	23:14	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:23	23:54	11号线	4分37秒	6分钟<br>
碧头	06:28	00:12	11号线	4分37秒	6分钟<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
A出入口:<br>
宝安大道西侧、福洲大道南侧、同泰时代购物广场、深圳同泰万怡酒店、汉永瑞酒店、福海信息港<br><br>
B出入口:<br>
宝安大道西侧、星港同创汇、维也纳酒店<br><br>
C出入口:<br>
宝安大道东侧、金域豪庭<br><br>
D出入口:<br>
宝安大道东侧、福洲大道南侧、兴飞宇大厦、中阳商务大厦、福永意库<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 日生站<br>
M220、M308、M317、M322、M447、M458<br><br>
B出入口:<br>
公交站名： 龙岗智慧家园站<br>
M220、M308、M317、M322、M458<br><br>
C出入口:<br>
公交站名： 龙岗智慧家园站<br>
M220、M308、M317、M322、M458<br><br>
D出入口:<br>
公交站名： 日生站<br>
M220、M308、M317、M322、M458、M447<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiyihaoxian",
            title: "11号线",
            // icon: "chat",
            exact: true,
          },
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>